import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

type Props = {
  children: string | string[];
  isError?: boolean;
};

export const SubText = ({children, isError}: Props) => {
  if (isError) {
    return (
      <Tailwind>
        <p className="mt-8 text-base text-red-500">{children}</p>
      </Tailwind>
    );
  }
  return (
    <Tailwind>
      <p className="mt-8 text-base text-moon-500">{children}</p>
    </Tailwind>
  );
};
